let navigateFunction = null;

export const setNavigateFunction = (navigate) => {
  navigateFunction = navigate;
};

export const navigate = (path, options) => {
  if (navigateFunction) {
    navigateFunction(path, options);
  } else {
    console.error('Navigate function is not initialized yet');
  }
};
